import { Injectable } from "@angular/core";
import { LoginService } from "@geolib/geoappbase-client";
import { StateService } from "@geolib/geoappbase-client";
import { StateObject, TransitionService } from "@uirouter/angular";
import { lastValueFrom, Observable, of } from "rxjs";
import { map } from "rxjs/operators";
import { AuthenticationService } from "./account/AuthenticationService";
import { IdentityService } from "./account/IdentityService";
import { AppStateMemory } from "./handbook/app-state-memory.service";
import { PrimaryAreaService } from "./primaryArea/primary-area.service";
import IUser from "./user/IUser";


@Injectable({ providedIn: "root" })
export default class AppInitializer {

    public constructor(
        private readonly transitionService: TransitionService,
        private readonly authenticationService: AuthenticationService,
        private readonly stateService: StateService,
        private readonly primaryAreaService: PrimaryAreaService,
        private readonly identityService: IdentityService,
        private readonly loginService: LoginService,
        private readonly appStateMemory: AppStateMemory,
    ) {
        this.registerStateChangeListener();
        this.registerLogoutListener();
        this.appStateMemory.registerAppStateListener();
    }

    private registerStateChangeListener(): void {
        this.transitionService.onBefore({ to: (state: StateObject) => !state.data?.public }, (transition) => {
            return lastValueFrom(this.getUser()).then((user) => {
                if (user) {
                    const params = transition.params();

                    return this.primaryAreaService.getCanton().subscribe(({ canton }) => {
                        if (!params?.primaryArea || params.primaryArea !== canton) {
                            transition.abort();

                            const toState = transition.to();

                            if (toState.name) {
                                return this.stateService.go(toState.name, { ...params, primaryArea: canton });
                            } else {
                                return this.stateService.go("home");
                            }
                        }
                    });
                } else {
                    transition.abort();
                    return this.stateService.go("home");
                }
            }).catch(() => this.stateService.go("home")).then(() => undefined);
        });
    }

    private getUser(): Observable<IUser> {
        if (this.identityService.currentUser) {
            return of(this.identityService.currentUser);
        } else {
            return this.authenticationService.getUser().pipe(
                map((response) => {
                    return response.user;
                }),
            );
        }
    }

    private registerLogoutListener(): void {
        this.loginService.onLogout(() => {
            this.identityService.currentUser = undefined;
            this.stateService.go("home");
        });
    }

}
